var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#13AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6832 21.9453C30.1041 14.9761 26.3721 12.6846 25.9703 11.8091C25.5308 11.1914 25.0855 10.0928 25.0855 10.0928C25.0782 10.0742 25.0665 10.0415 25.0528 10.0098C25.0074 10.6274 24.9839 10.8657 24.4 11.4888C23.4957 12.1958 18.856 16.0889 18.4786 24.0068C18.1265 31.3916 23.813 35.792 24.5821 36.353L24.6695 36.415V36.4097C24.6744 36.4468 24.9136 38.1675 25.0816 39.9907H25.6841C25.8255 38.7019 26.0374 37.4219 26.3189 36.1562L26.3677 36.1245C26.7117 35.8779 27.0397 35.6096 27.3497 35.3213L27.3848 35.2896C29.0196 33.7793 31.9585 30.2861 31.9297 24.7168C31.9236 23.7878 31.8412 22.8608 31.6832 21.9453ZM25.0176 32.1836C25.0176 32.1836 25.0176 21.8262 25.3594 21.8281C25.626 21.8281 25.9712 35.188 25.9712 35.188C25.4966 35.1309 25.0176 32.9893 25.0176 32.1836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.f4ed64fd3c6637bd0ada88cddc3c3090.svg";
export { ForwardRef as ReactComponent };